function initStorelocater() {
    if (!document.getElementById('shop-map') && !document.getElementById('shop-map-footer')) return;
    let markers = [];
    let footermarkers = [];
    let infowindows = [];
    var mapwrapper, shopfootermap;
    var locationData = [];



    function initMap() {

        var mapOpts = {
            center: { lat: 30.3110358, lng: -89.32669550000003 },
            zoom: 11,
            mapTypeControl: false,
            styles:
                [
                    {
                        "featureType": "road.local",
                        "stylers": [
                            {
                                "weight": 4.5
                            }
                        ]
                    }
                ]
        };

        if (document.getElementById('shop-map-footer')) {
            shopfootermap = new google.maps.Map(document.getElementById('shop-map-footer'), {
                ...mapOpts,
                center: {
                    lat: 50.748225, 
                    lng: -2.040234,
                },
                zoom: 9,
                mapTypeControl: false,
                scaleControl: false,
                streetViewControl: false,
                rotateControl: false,
                fullscreenControl: false,
                draggable: true,
                zoomControl: true,
                scrollwheel: true,
            });
            shopfootermap.setOptions({ styles: styles.light });

        }

        if (document.getElementById('shop-map')) {
            mapwrapper = new google.maps.Map(document.getElementById('shop-map'), mapOpts);
            mapwrapper.setOptions({ styles: styles.dark });
            google.maps.event.addListener(mapwrapper, 'bounds_changed', function () {
                boundsChangedHandle();
            });
        }

        // var bicyclayer = new google.maps.BicyclingLayer();
        // bicyclayer.setMap(map);       

    }


    function getDistance(lat1, lon1, lat2, lon2, unit) {
        var radlat1 = Math.PI * lat1 / 180
        var radlat2 = Math.PI * lat2 / 180
        var theta = lon1 - lon2
        var radtheta = Math.PI * theta / 180
        var dist = Math.sin(radlat1) * Math.sin(radlat2) + Math.cos(radlat1) * Math.cos(radlat2) * Math.cos(radtheta);
        if (dist > 1) {
            dist = 1;
        }
        dist = Math.acos(dist)
        dist = dist * 180 / Math.PI
        dist = dist * 60 * 1.1515
        if (unit == "K") { dist = dist * 1.609344 }
        if (unit == "N") { dist = dist * 0.8684 }
        return dist
    }


    function init() {
       
        initMap();

        if (document.getElementById('shop-map')){
            var endpoint = 'https://tinybotvinyl.wolfmanapps.com/api/search/stores?perpage=200';
            // console.log(endpoint)
            $.get({
                url: endpoint,
                success: function (responce) {
                    loading = false;
                    locationData = responce.data;
                    for (i = 0; i < locationData.length; i++) {
                        locationData[i].position = i;
                    }
                    // console.log(locationData)
                    initMapMarkers(locationData);

                }
            })
        }

        addFooterMarker({
            store_name: "Tinybot Canada",
            address: "Lytchett House, 13 Freeland Park, Wareham Road, Poole, Dorset, BH16 6FA",
            email: "support@tinybotvinyl.ca",
            phone: "+1 310-607-8241",
            lat: "50.748225",
            lng: "-2.040234",
        })
    }

    function initMapMarkers(locationData) {
        removeAllMarkers();
        locationData.forEach(function (location, index) {
            addMarker(location, index);
        });

        populateMarkers(locationData);
        boundMarkers(markers, mapwrapper);
        

        // boundMarkers(footermarkers, shopfootermap);
    }

    function populateMarkers(locations) {
        $('#print').html('');
        // removeAllMarkers();
        locations.forEach(populateLocationList);
        // boundMarkers(markers);
    }

    function boundsChangedHandle() {
        // let address = $('#searchInput').val();
        // if(address != ''){
        var visibleLocations = [];
        for (var i = 0; i < locationData.length; i++) {
            if (mapwrapper.getBounds().contains(markers[i].getPosition())) {
                visibleLocations.push(locationData[i]);
            }
        }
        // console.log(visibleLocations)
        showLocations(visibleLocations);
        // }else{
        //   showLocations(locationData);
        // }
    }

    function showLocations(locations) {
        $(`.poi-item`).hide();
        locations.forEach(function (location) {
            $(`.poi-item[data-index="${location.position}"]`).show();
        });
        // let positions = locations.map(item => item.position);
        // var markerAtPos = [];
        // positions.forEach(function(pos){
        //   markerAtPos.push(markers[pos]);
        // });
        // boundMarkers(markerAtPos);
    }

    function boundMarkers(markersList, mapObject) {
        var bounds = new google.maps.LatLngBounds();
        if (centerMarker) {
            bounds.extend(centerMarker.getPosition());
        }
        for (var i = 0; i < markersList.length; i++) {
            bounds.extend(markersList[i].getPosition());
        }
        if (mapObject) {
            mapObject.maxDefaultZoom = 11;
            mapObject.initialZoom = true;
            mapObject.fitBounds(bounds);
        }
    }

    function removeAllMarkers() {
        for (let i = 0; i < markers.length; i++) {
            markers[i].setMap(null);
        }
        markers = [];
    }

    // function replaceNbsps(str) {
    //     var re = new RegExp(String.fromCharCode(160), "g");
    //     return str.replace(re, " ");
    // }

    function populateLocationList(location, index) {
        var list_data = `<div class="poi-item item actions" data-index="${index}">
                        <div class="icon">
                            <svg width="18" height="25" viewBox="0 0 18 25" fill="none"><path d="M7.875 23.8116C5.4375 20.7647 0 13.4991 0 9.37405C0 4.4053 3.98438 0.374054 9 0.374054C13.9688 0.374054 18 4.4053 18 9.37405C18 13.4991 12.5156 20.7647 10.0781 23.8116C9.51562 24.5147 8.4375 24.5147 7.875 23.8116ZM9 12.3741C10.6406 12.3741 12 11.0616 12 9.37405C12 7.73343 10.6406 6.37405 9 6.37405C7.3125 6.37405 6 7.73343 6 9.37405C6 11.0616 7.3125 12.3741 9 12.3741Z" fill="#EA3223"></path></svg>
                        </div>
                        <div class="content ">
                            ${location.store_name ? `<h2>${location.store_name}</h2>` : ``}
                            ${location.address ? `<p>${location.address}</p>` : ``}
                            ${location.email ? `<p>${location.email}</p>` : ``}
                            ${location.phone ? `<p>${location.phone}</p>` : ``}
                            <a href="javascript:void(0);"  data-lat="${location.lat}" data-lng="${location.lng}" class="ABlue_12R justhideit showifOne1 get-direction">Get Directions</a>
                        </div>
                        </div>`
        $('#shop_partners_list').append(list_data);
        // addMarker(location, index);
    }

    let lastClickedIndex = -1;
    var lastInfoWindow = null;
    const infowincontent = '<div style="min-width: 150px;max-width:250px;word-wrap:break-word;">CONTENT</div>';
    var centerMarker = null;
    // var pinImage = new google.maps.MarkerImage("{{ 'pointer.png' | asset_url }}");
    function addFooterMarker(item) {
        if (shopfootermap) {
            let markerfooter = new google.maps.Marker({
                position: { lat: parseFloat(item.lat), lng: parseFloat(item.lng) },
                map: shopfootermap,
                title: item.Name,
                // icon: pinImage,
                animation: google.maps.Animation.DROP
            });


            let infowindow = new google.maps.InfoWindow({
                content: infowincontent.replace('CONTENT', `<div class="mapmarker">
            ${item.store_name ? `<h2 class="store_name">${item.store_name}</h2>` : ``}
            ${item.address ? `<p class="address">${item.address}</p>` : ``}
            ${item.email ? `<p class="email">${item.email}</p>` : ``}
            ${item.phone ? `<p class="phone">${item.phone}</p>` : ``}
            <br/><a class="direction-info" data-index="${item.position}" target="_blank" href="https://google.com/maps/dir/?api=1&destination=${item.lat},${item.lng}">Get Directions</a></div>`)
            });
            footermarkers.push(markerfooter);
            infowindows.push(infowindow);
            google.maps.event.addListener(markerfooter, 'click', function () {
                // if (lastClickedIndex != index) {
                // lastClickedIndex = index;
                // $(`ul.poi-result li`).removeClass('active');
                // $(`ul.poi-result li`).eq(index).addClass('active');
                openInfoWindow(infowindow, markerfooter);
                // }
            });
            google.maps.event.addListener(infowindow, 'closeclick', function () {
                lastClickedIndex = -1;
            });
        }
    }
    function addMarker(item, index) {
        // console.log(item)
        if (mapwrapper) {
            let marker = new google.maps.Marker({
                position: { lat: parseFloat(item.lat), lng: parseFloat(item.lng) },
                map: mapwrapper,
                title: item.Name,
                // icon: pinImage,
                animation: google.maps.Animation.DROP
            });

            let infowindow = new google.maps.InfoWindow({
                content: infowincontent.replace('CONTENT', `<div class="mapmarker">
            ${item.store_name ? `<h2 class="store_name">${item.store_name}</h2>` : ``}
            ${item.address ? `<p class="address">${item.address}</p>` : ``}
            ${item.email ? `<p class="email">${item.email}</p>` : ``}
            ${item.phone ? `<p class="phone">${item.phone}</p>` : ``}
            <br/><a class="direction-info" data-lat="${item.lat}"  data-lat="${item.lng}" target="_blank" href="https://google.com/maps/dir/?api=1&destination=${item.lat},${item.lng}">Get Directions</a></div>`)
            });
            markers.push(marker);
            infowindows.push(infowindow);
            google.maps.event.addListener(marker, 'click', function () {
                if (lastClickedIndex != index) {
                    lastClickedIndex = index;
                    $(`ul.poi-result li`).removeClass('active');
                    $(`ul.poi-result li`).eq(index).addClass('active');
                    // $('#poiEl').animate({scrollTop: 0}, 0, function() {
                    //   let top = $(`ul.poi-result li.poi-item.active`).offset().top;
                    //   $('#poiEl').animate({scrollTop: (top - 300)}, 100);
                    // });
                    openInfoWindow(infowindow, marker);
                }
            });
            google.maps.event.addListener(infowindow, 'closeclick', function () {
                lastClickedIndex = -1;
            });
        }

    }

    function getlatlongfromAddress(address) {
        if (address == '') {
            showLocations(locationData)
            return;
        }
        var geocoder = new google.maps.Geocoder();

        geocoder.geocode({ 'address': address }, function (results, status) {
            if (status == google.maps.GeocoderStatus.OK) {
                var latitude = results[0].geometry.location.lat();
                var longitude = results[0].geometry.location.lng();
                var newList = locationData.map(location => {
                    location.distance = getDistance(latitude, longitude, location.lat, location.lng, 'K')
                    console.log(location.distance);
                    return location;
                });
                // centerMarker = new google.maps.Marker({position: {lat: latitude, lng: longitude}});

                newList.sort(function (a, b) { return a.distance - b.distance });
                var filterData = newList.filter(item => {
                    return item.distance <= 50;
                });
                if (filterData.length == 0) {
                    filterData = newList.slice(0, 2);
                }
                let positions = filterData.map(item => item.position);
                var markerAtPos = [];
                positions.forEach(function (pos) {
                    markerAtPos.push(markers[pos]);
                });

                showLocations(filterData);
                boundMarkers(markerAtPos, mapwrapper);
            } else {
                return false;
            }
        });
    }

    function openInfoWindow(infowindow, marker) {
        if (lastInfoWindow) {
            lastInfoWindow.close();
        }
        lastInfoWindow = infowindow;
        infowindow.open({ anchor: marker, mapwrapper });
    }
    $(document).on('submit', '#shopSearchForm',function(e){
        e.preventDefault();
        let address = $('#searchMapInput').val();
        getlatlongfromAddress(address);
        resizeWindowStore();
    })
    jQuery(document).on('click', '.searchMaplocation', function (e) {
        e.preventDefault();
        let address = $('#searchMapInput').val();
        getlatlongfromAddress(address);
        resizeWindowStore();
    });
    jQuery(window).resize(function () {
        resizeWindowStore();
    });

    function resizeWindowStore() {
        // let ele = $('#poiEl');
        // let width = jQuery(window).width();
        // if (width < 992) {
        //     if (ele.hasClass('show')) {
        //         ele.removeClass('show');
        //     }
        // }
    }
    
    $(document).on('click', '.actions .get-direction, .direction-info', function (e) {
        e.preventDefault();
        let lat = $(this).data('lat');
        let lng = $(this).data('lng');
        openGoogleMap(lat, lng);
    });


    function openGoogleMap(lat, lng) {
        lat = parseFloat(lat);
        long = parseFloat(lng);

        window.open(`https://www.google.com/maps/dir/?api=1&travelmode=driving&layer=traffic&destination=${lat},${long}`);
    }
    // jQuery(document).on('click', '.stores-events-toggle', function () {
    //     let ele = $('#poiEl');
    //     if (ele.hasClass('active')) {
    //         ele.removeClass('active');
    //     } else {
    //         ele.addClass('active');
    //     }
    // });
    jQuery(document).on('click', '.showLocation', function () {
        let ele = $('#poiEl');
        if (ele.hasClass('show')) {
            ele.removeClass('show');
        } else {
            ele.addClass('show');
        }
    });
    jQuery(document).on('click', '.hide-location', function () {
        let ele = $('#poiEl');
        if (ele.hasClass('show')) {
            ele.removeClass('show');
        } else {
            ele.addClass('show');
        }
    });

    // jQuery(window).resize(function(){
    //   resizeWindowStore();
    // });
    // function resizeWindowStore()
    // {
    //     let width = jQuery(window).width();
    //     if(width > 992){
    //       jQuery('.poielement').addClass('active');
    //     }else{
    //       jQuery('.poielement').removeClass('active');
    //     }
    // }
    jQuery(document).on('click', '.poi-item', function () {
        $('.poi-item').removeClass('active');
        $(this).addClass('active');
        let index = parseInt($(this).index('.poi-item'));
        let marker = markers[index];
        let info = infowindows[index+1];
        var latLng = marker.getPosition(); // returns LatLng object
        mapwrapper.panTo(latLng);
        // map.setZoom(9);
        openInfoWindow(info, marker);
        if ($(window).width() <= 767) {
            $('.hide-location').trigger('click');
        }
    });

    const styles = {
        default: [],
        dark: [
            {
                elementType: "labels.icon",
                stylers: [{ visibility: "off" }],
            },
            {
                "elementType": "geometry",
                "stylers": [
                    {
                        "color": "#12171D"
                    }
                ]
            },
            {
                "elementType": "labels.text.fill",
                "stylers": [
                    {
                        "color": "#746855"
                    }
                ]
            },
            {
                "elementType": "labels.text.stroke",
                "stylers": [
                    {
                        "color": "#12171D"
                    }
                ]
            },
            {
                "featureType": "administrative.locality",
                "elementType": "labels.text.fill",
                "stylers": [
                    {
                        "color": "#d59563"
                    }
                ]
            },
            {
                "featureType": "poi",
                "elementType": "labels.text.fill",
                "stylers": [
                    {
                        "color": "#d59563"
                    }
                ]
            },
            {
                "featureType": "poi.park",
                "elementType": "geometry",
                "stylers": [
                    {
                        "color": "#263c3f"
                    }
                ]
            },
            {
                "featureType": "poi.park",
                "elementType": "labels.text.fill",
                "stylers": [
                    {
                        "color": "#6b9a76"
                    }
                ]
            },
            {
                "featureType": "road",
                "elementType": "geometry",
                "stylers": [
                    {
                        "color": "#38414e"
                    }
                ]
            },
            {
                "featureType": "road",
                "elementType": "geometry.stroke",
                "stylers": [
                    {
                        "color": "#212a37"
                    }
                ]
            },
            {
                "featureType": "road",
                "elementType": "labels.text.fill",
                "stylers": [
                    {
                        "color": "#9ca5b3"
                    }
                ]
            },
            {
                "featureType": "road.highway",
                "elementType": "geometry",
                "stylers": [
                    {
                        "color": "#746855"
                    }
                ]
            },
            {
                "featureType": "road.highway",
                "elementType": "geometry.stroke",
                "stylers": [
                    {
                        "color": "#1f2835"
                    }
                ]
            },
            {
                "featureType": "road.highway",
                "elementType": "labels.text.fill",
                "stylers": [
                    {
                        "color": "#f3d19c"
                    }
                ]
            },
            {
                "featureType": "transit",
                "elementType": "geometry",
                "stylers": [
                    {
                        "color": "#2f3948"
                    }
                ]
            },
            {
                "featureType": "transit.station",
                "elementType": "labels.text.fill",
                "stylers": [
                    {
                        "color": "#d59563"
                    }
                ]
            },
            {
                "featureType": "water",
                "elementType": "geometry",
                "stylers": [
                    {
                        "color": "#17263c"
                    }
                ]
            },
            {
                "featureType": "water",
                "elementType": "labels.text.fill",
                "stylers": [
                    {
                        "color": "#515c6d"
                    }
                ]
            },
            {
                "featureType": "water",
                "elementType": "labels.text.stroke",
                "stylers": [
                    {
                        "color": "#17263c"
                    }
                ]
            }
        ]
    };
    jQuery(document).ready(function ($) {
        resizeWindowStore();
    });
    // document.addEventListener('touchmove', function (event) {
    //     if (event.scale !== 1) { event.preventDefault(); }
    // }, { passive: false });
    init();
}

